module.exports = __webpack_public_path__ + "img/symbol_4.d934e0d4.png";